import * as dc from "@/components/layout/list/defaultType";
import { DataListParams, DataListProp } from "../../layoutType";
import { getMatchingSelectData, runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { equipClipboard } from "../../inputCols/clipboard";
import { enLocale } from "@/i18n/routing";
export const RoasterItem = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;

  const utcOffset = dayjs().utcOffset() * 60000;
  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_equip_list","system_table_pk":["roaster_seq","roaster_equip_seq"],"system_table_page":"RoasterEquip","system_table_path":"roaster/item/equip","system_table_page_name":"RoasterEquip","system_table_auth":["SADMIN","ADMIN","USER","ROASTER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_roaster_auth_field":["equip_auth"],"system_table_mapper":"roaster","system_table_detail_result":"detail_result","system_table_search_column":["equip_type"],"system_table_search_select":["equip_name_locale","equip_name"],"system_table_order_column":["equip_type","equip_name_locale"],"system_table_default_name_column":"equip_name_locale","system_table_en_name_column":"equip_name"},
    //--info--"change":{"equip_type":{"COLUMN_CODE_SELECT":"EQUIP"},"equip_type_list":{"COLUMN_CODE_SELECT":"EQUIP"}}
    //--info--}

    case "RoasterEquip":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/item/equip/detail/", saveFetch: { fetchUrl: "/api/roaster/item/equip/edit" } },
        listFetch: { fetchUrl: "/api/roaster/item/equip/list" },
        dataResultName: "detail_result",
        dataName: "RoasterEquipData",
        clipboard: equipClipboard(formFunction?.current),
        dataCols: {
          //roaster_equip_seq: { ...dc.seq },
          equip_name_locale: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
          equip_name: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
          equip_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true },
          equip_nick: { ...dc.inputFull, maxLength: 300, showCount: true },
          equip_type: {
            ...dc.select,
            inputClassName: dc.inputCountryClassName,
            required: true,
            minLength: 3,
            maxLength: 45,
            codeGroup: "EQUIP",
            selectChangeLoad: ["equip_manufacture_seq", "equip_seq"],
          },
          equip_manufacture_seq: {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/code/company",
            dataProp: {
              fixedParam: { company_type: "EQD" },
              requiredParam: ["company_type"],
              userAuth: false,
              load: (data, select_data) => {
                // Debug(select_data);
                // const temp_link_function = formFunction?.current.greenbean_seller_link;
                // if (temp_link_function) {
                //   setTimeout(() => {
                //     form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
                //     if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
                //   }, 500);
                // }
              },
            },
            dataLabel: {
              value: "company_seq",
              label: [
                { field: "company_name_locale", subs: "company_nick_locale" },
                { field: "company_name", subs: "company_nick" },
              ],
            },
            selectFieldFilter: { company_type_list: "equip_type" },
            selectChangeLoad: ["equip_seq"],
          },
          equip_seq: {
            ...dc.selectSearch,
            label: "equip_ref_seq",
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/code/product/equip",
            dataProp: {
              //fixedParam: { company_type: "EQD" },
              valueParam: { equip_type: "equip_type", equip_manufacture_seq: "equip_manufacture_seq" },
              requiredParam: ["equip_type", "equip_manufacture_seq"],
              userAuth: false,
              // load: (data, select_data) => {
              // },
            },
            onChange: (data) => {
              const result = getMatchingSelectData(form?.current, formFunction?.current, formMemo?.current, "equip_seq", [
                "equip_seq",
                "edit_at",
              ]);
              //Debug(result);
              form?.current?.setFieldsValue(result);
              setTimeout(() => {
                runFormFunction(formFunction?.current, ["equip_type", "equip_manufacture_seq"], "changeLoad");
              }, dc.setTimeoutShort);
              //greenbean_region_seq, greenbean_farm_seq
            },
            dataLabel: {
              //equip_seq, equip_name, equip_name_locale, equip_nick, equip_nick_locale, equip_type, equip_type_list, equip_manufacture_seq, equip_detail, edit_at
              value: "equip_seq",
              label: [
                { field: "equip_name_locale", subs: "equip_nick_locale" },
                { field: "equip_name", subs: "equip_nick" },
              ],
            },
          },
          equip_auth: {
            ...dc.roasterAuth,
            inputClassName: dc.inputCountryClassName,
            label: "select_auth",
          },
          equip_zero_point: { ...dc.number2f },
          equip_option: { ...dc.textArea, maxLength: 10000 },
          equip_detail: { ...dc.textArea, maxLength: 10000 },
          equip_purchase_date: { ...dc.date },
          equip_use: { ...dc.useDefault, required: true },
          rgst_by: { ...dc.rgst },
          edit_by: { ...dc.edit },
        },

        listColLinkField: "roaster_equip_seq",
        listSearch: [
          { ...dc.select, inputType: "select", codeGroup: "EQUIP", field: "search0", label: "equip_type", placeholder: "equip_type" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "equip_name_locale", placeholder: "equip_name_locale" },
          // { ...dc.input, field: "search_type0", label: "equip_name_locale", placeholder: "equip_name_locale" },
          // { ...dc.input, field: "search_type1", label: "equip_name", placeholder: "equip_name" },
        ],
        listOrder: ["equip_type_orderasc", "equip_type_orderdesc", "equip_name_locale_orderasc", "equip_name_locale_orderdesc"],
        listCols: [
          //"roaster_seq",
          // "roaster_equip_seq",
          params?.locale === enLocale ? "equip_name" : "equip_name_locale",
          //"equip_nick",
          //"equip_nick_locale",
          { field: "equip_type", codeGroup: "EQUIP", selectProp: { mode: "multiple" } },
          //{ field: "equip_type_list", codeGroup: "EQUIP", inputDirect: "equip_type_list", selectProp: { mode: "multiple" } },
          //"equip_manufacture_seq",
          //"equip_detail",
          //"equip_option"
        ],
      };
    default:
      return undefined;
  }
};
